import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import React from 'react';
import classNames from 'classnames';

function Marks(props) {
  var _context, _context2, _context3;

  var marks = props.marks,
      prefixCls = props.prefixCls,
      vertical = props.vertical,
      reverse = props.reverse,
      min = props.min,
      max = props.max,
      bound = props.bound,
      onClickLabel = props.onClickLabel;
  var range = max - min;

  var elements = _mapInstanceProperty(_context = _sortInstanceProperty(_context2 = _mapInstanceProperty(_context3 = _Object$keys(marks)).call(_context3, parseFloat)).call(_context2, function (a, b) {
    return a - b;
  })).call(_context, function (point) {
    var _classNames;

    // 判断label元素 可能是reactNode 也可能是{label: reactNode, style: css}
    var markNode = marks[point];
    var isObject = _typeof(markNode) === 'object' && ! /*#__PURE__*/React.isValidElement(markNode);
    var markLabelElement = isObject ? markNode.label : markNode;
    var markLabelStyle = isObject ? markNode.style : null; // 根据vertical和reverse判断mark的样式

    var offset = "".concat(Math.abs(point - min) / range * 100, "%");
    var markStyle = vertical ? _extends(_defineProperty({}, reverse ? 'top' : 'bottom', offset), markLabelStyle) : _extends(_defineProperty({}, reverse ? 'right' : 'left', offset), markLabelStyle);
    var isActived = bound >= point;
    var markClass = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-mark-text"), true), _defineProperty(_classNames, "".concat(prefixCls, "-mark-text-actived"), isActived), _classNames));
    return /*#__PURE__*/React.createElement("span", {
      className: markClass,
      key: point,
      style: markStyle,
      onMouseDown: function onMouseDown(e) {
        return onClickLabel(e, point);
      },
      onTouchStart: function onTouchStart(e) {
        return onClickLabel(e, point);
      }
    }, markLabelElement);
  });

  var marksClass = classNames("".concat(prefixCls, "-mark"), _defineProperty({}, "".concat(prefixCls, "-reverse"), reverse));
  return /*#__PURE__*/React.createElement("div", {
    className: marksClass
  }, elements);
}

export default Marks;